import { GeofenceType } from 'constants/geofence';
import { IntlShape } from 'react-intl';
import { GeofenceRule } from 'services/resources';

const localeGeofenceNameMapping = {
  en: 'name',
  fr: 'nameFr',
} as const;

export const getIntlName = (geofenceRule: GeofenceRule, intl: IntlShape) => {
  const nameKey = localeGeofenceNameMapping[intl.locale.split('-')[0]];
  if (geofenceRule.geofence.geofenceType === GeofenceType.WORLD) {
    return geofenceRule.geofence[nameKey];
  }

  return geofenceRule.geofence.name;
};
